module.exports = __webpack_public_path__ + "static/media/parts_01.7b1e5895.svg";